import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sort from "./Sort";
// Ikony używane tylko w LockSystemRow
// import { apiServer } removed

import { backendUrl } from "../backendUrl";
import LoadingPage from "../LoadingPage";
import { SystemInfo, Configuration, ConfigurationDetail } from "./types";
import { getDataFromSession, storeDataInSession } from "./helpers";
import LockSystemRow from "./LockSystemRow";

interface Supplier {
  id: number;
  name: string;
  icon_path: string;
  display_order: number;
  is_active: number;
}

function ChooseLockSystem() {
  // Detekcja urządzeń mobilnych - działa też w narzędziach deweloperskich (F12)
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const detectMobile = () => {
      const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      const isMobileScreen = window.innerWidth < 960; // breakpoint dla mobile
      
      // Wystarczy mała szerokość LUB mobilny user agent
      return isMobileScreen || isMobileUserAgent;
    };

    const handleResize = () => {
      setIsMobile(detectMobile());
    };
    
    handleResize();
    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);
    
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, []);

  // State for mobile filter modal
  const [showMobileFilter, setShowMobileFilter] = useState(false);

  const [doors] = useState(() => getDataFromSession("doors", []));
  const [keys] = useState(() => getDataFromSession("keys", []));
  const [pageIsLoaded, setPageIsLoaded] = useState<boolean>(false);
  const [supplierIconMap, setSupplierIconMap] = useState<Record<string, string>>({});
    const [configuration, setConfiguration] = useState<ConfigurationDetail>({
    filteredResult: [],
    maxValue: "",
    minValue: "",
  });
  const [configurationOriginal, setConfigurationOriginal] = useState<ConfigurationDetail>({
    filteredResult: [],
    maxValue: "",
    minValue: "",
  });
  const [sort, setSort] = useState("");
  const [taxRate, setTaxRate] = useState<number>(19); // default to 19% if fetch fails

  // Usunięto lokalne sortowanie, sortowanie obsługuje backend

  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const response = await axios.get(`${backendUrl}/api/v1/configurator/suppliers/active`);
        if (response && response.data) {
          const iconMap: Record<string, string> = {};
          response.data.forEach((supplier: Supplier) => {
            iconMap[supplier.name] = supplier.icon_path;
          });
          setSupplierIconMap(iconMap);
        }
      } catch (error) {
        console.error("Błąd podczas pobierania dostawców:", error);
      }
    };
    fetchSuppliers();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${backendUrl}/api/v1/configurator/systemsInfo`
        );
        if (response && response.data) {
          setTableData(response.data);
        } else {
          setTableData([]);
        }
      } catch (error) {
        console.error("Błąd podczas pobierania danych:", error);
        setTableData([]);
      }
      try {
        const response = await axios.post(
          `${backendUrl}/api/v1/configurator/configuration?sortby=${sort}`,
          [{ doors, keys }]
        );
        if (response && response.data) {
          setConfiguration(response.data);
          setConfigurationOriginal(response.data);
        } else {
          setConfiguration({ filteredResult: [], maxValue: "", minValue: "" });
          setConfigurationOriginal({ filteredResult: [], maxValue: "", minValue: "" });
        }
      } catch (error) {
        console.error("Błąd podczas pobierania danych:", error);
        setConfiguration({ filteredResult: [], maxValue: "", minValue: "" });
        setConfigurationOriginal({ filteredResult: [], maxValue: "", minValue: "" });
      } finally {
        setPageIsLoaded(true);
      }
    };
    fetchData();
  }, [doors, keys, sort]);

  const toggleRow = (index: number) => {
    const updatedRows = [...expandedRows];
    const rowIndex = updatedRows.indexOf(index);
    if (rowIndex === -1) {
      updatedRows.push(index);
    } else {
      updatedRows.splice(rowIndex, 1);
    }
    setExpandedRows(updatedRows);
  };
  // const permission = getDataFromSession("permission", []); // nieużywane
  const [tableData, setTableData] = useState<SystemInfo[]>([]);
  const [expandedRows, setExpandedRows] = useState<number[]>([]);
  const storeData = storeDataInSession;
  const handleOnSelectSystem = (supllier: String, system1: String) => {
    storeData("supllier", supllier);
    storeData("system1", system1);
  };
  const handleSortChange = (currentSort: string, sort: string) => {
    let newSortChoice: string = "priceUp";
    if (currentSort.startsWith("price") && sort.startsWith("price")) {
      switch (currentSort) {
        case "priceUp":
          newSortChoice = "priceDown";
          break;
        case "priceDown":
          newSortChoice = "priceUp";
          break;
      }
    } else if (currentSort.startsWith("price") && sort.startsWith("supllier")) {
      switch (currentSort) {
        case "supllierAZ":
          newSortChoice = "supllierZA";
          break;
        case "supllierZA":
          newSortChoice = "supllierAZ";
          break;
        default:
          newSortChoice = "supllierAZ";
      }
    }
    if (currentSort.startsWith("supllier") && sort.startsWith("supllier")) {
      switch (currentSort) {
        case "supllierAZ":
          newSortChoice = "supllierZA";
          break;
        case "supllierZA":
          newSortChoice = "supllierAZ";
          break;
      }
    } else if (
      currentSort.startsWith("supllier") &&
      sort.startsWith("supllier")
    ) {
      switch (currentSort) {
        case "priceUp":
          newSortChoice = "priceDown";
          break;
        case "priceDown":
          newSortChoice = "priceUp";
          break;
        default:
          newSortChoice = "priceUp";
      }
    }
    setSort(newSortChoice);
  };

  // Fetch tax rate on component mount
  useEffect(() => {
    const fetchTaxRate = async () => {
      try {
        const response = await axios.get(
          `${backendUrl}/api/v1/configurator/tax-rate`
        );
        if (response.data && typeof response.data.rate === "number") {
          setTaxRate(response.data.rate);
        }
      } catch (err) {
        console.error("Error fetching tax rate:", err);
        // fallback to 19% on error
      }
    };
    fetchTaxRate();
  }, []);

  return (
    <div
      className="choose-lock-system"
      style={{ 
        width: isMobile ? "95%" : "75%", 
        margin: isMobile ? "20px auto" : "65px auto", 
        overflow: "hidden",
        padding: isMobile ? "0 10px" : "0"
      }}
    >
      {/* Tytuł */}
      <div style={{ textAlign: "left", margin: "20px 0", padding: "1rem" }}>
        <p
          style={{
            fontSize: "1.2rem",
            fontWeight: 800,
            display: "flex",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <img
            src={`${backendUrl}/img/2.png`}
            alt="Tytuł"
            style={{ width: "1.2rem", marginRight: "0.3rem" }}
          />
          Wählen Sie Ihre Schließanlage
        </p>
        
        {/* Desktop filter - show only on desktop */}
        {!isMobile && (
          <Sort
            configuration={configuration}
            configurationOriginal={configurationOriginal}
            onConfigurationChange={setConfiguration}
            sort={sort}
            price={{
              minPrice:
                configuration.minValue && !isNaN(Number(configuration.minValue))
                  ? String(configuration.minValue)
                  : "",
              maxPrice:
                configuration.maxValue && !isNaN(Number(configuration.maxValue))
                  ? String(configuration.maxValue)
                  : "",
            }}
          />
        )}
        
        {/* Results count with mobile filter button */}
        <div className="results-header">
          <div className="results-info">
            <span className="results-count">
              Ergebnisse {configuration.filteredResult.length}
            </span>
          </div>
          
          {/* Mobile filter icon - positioned next to results */}
          {isMobile && (
            <button
              onClick={() => setShowMobileFilter(true)}
              className="mobile-filter-icon"
              title="Filter und Sortierung"
            >
              <svg 
                width="20" 
                height="20" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path 
                  d="M4 6H20M7 12H17M10 18H14" 
                  stroke="white" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          )}
        </div>
      </div>
      
      {/* Mobile Filter Modal */}
      {isMobile && showMobileFilter && (
        <div 
          className="mobile-filter-overlay"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setShowMobileFilter(false);
            }
          }}
        >
          <div className="mobile-filter-modal">
            {/* Close button */}
            <button
              onClick={() => setShowMobileFilter(false)}
              className="mobile-filter-close"
            >
              ×
            </button>
            
            {/* Title */}
            <h3 className="mobile-filter-title">
              Filter und Sortierung
            </h3>
            
            {/* Filter content */}
            <Sort
              configuration={configuration}
              configurationOriginal={configurationOriginal}
              onConfigurationChange={setConfiguration}
              sort={sort}
              price={{
                minPrice:
                  configuration.minValue && !isNaN(Number(configuration.minValue))
                    ? String(configuration.minValue)
                    : "",
                maxPrice:
                  configuration.maxValue && !isNaN(Number(configuration.maxValue))
                    ? String(configuration.maxValue)
                    : "",
              }}
            />
            
            {/* Apply button */}
            <div className="mobile-filter-button-container">
              <button
                onClick={() => setShowMobileFilter(false)}
                className="mobile-filter-apply"
              >
                Anwenden
              </button>
            </div>
          </div>
        </div>
      )}
      <br />
      {/* Tabela */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          border: isMobile ? "none" : "1px solid #ddd",
          borderBottom: "none",
        }}
      >
        {/* Mobile table header */}
        {isMobile && (
          <div className="mobile-table-header">
            <div 
              className="mobile-header-column product-column clickable"
              onClick={() => handleSortChange(sort, "supllierAZ")}
            >
              <span>Produkt</span>
              {sort.startsWith("supllier") && (
            <span className="mobile-sort-arrow">
              {sort === "supllierAZ" ? " ↑" : " ↓"}
            </span>
              )}
            </div>
            <div className="mobile-header-column properties-column">
              Eigenschaften
            </div>
            <div 
              className="mobile-header-column price-column clickable"
              onClick={() => handleSortChange(sort, "priceUp")}
            >
              <span>Preis inkl. MwSt. {taxRate}%</span>
              {sort.startsWith("price") && (
            <span className="mobile-sort-arrow">
              {sort === "priceUp" ? " ↑" : " ↓"}
            </span>
              )}
            </div>
          </div>
        )}

        {/* Nagłówek tabeli - tylko desktop */}
        {!isMobile && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            backgroundColor: "#005CA9",
            color: "#FFFFFF",
            height: "38px",
            alignContent: "center",
            flexFlow: "wrap",
            textAlign: "center",
          }}
        >
          <div
            style={{ flexBasis: "15%", flexGrow: 0, cursor: "pointer" }}
            onClick={(e) => handleSortChange(sort, "supllierAZ")}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingRight: "5%",
              }}
            >
              <p className="is-size-6 has-text-weight-bold">Produkt</p>
              <img
                className="vector"
                style={{
                  marginLeft: "5px",
                  width: "15px",
                  rotate:
                    sort === "supllierAZ"
                      ? "270deg"
                      : sort === "supllierZA"
                      ? "90deg"
                      : "",
                  display:
                    sort === "supllierAZ"
                      ? "block"
                      : sort === "supllierZA"
                      ? "block"
                      : "none",
                }}
                alt="Vector"
                src={`${backendUrl}/img/Vector.svg`}
              />
            </div>
          </div>
          <div style={{ flexBasis: "49%", flexGrow: 0 }}>
            <p className="is-size-6 has-text-weight-bold">Eigenschaften</p>
          </div>
          <div
            style={{ flexBasis: "18.5%", flexGrow: 0, cursor: "pointer" }}
            onClick={(e) => handleSortChange(sort, "priceUp")}
          >
            <div style={{ display: "flex" }}>
              <p className="is-size-6 has-text-weight-bold">
                Preis inkl. MwSt. 19%
              </p>
              <img
                className="vector"
                style={{
                  marginLeft: "5px",
                  width: "15px",
                  rotate:
                    sort === "priceUp"
                      ? "270deg"
                      : sort === "priceDown"
                      ? "90deg"
                      : "",
                  display:
                    sort === "priceUp"
                      ? "block"
                      : sort === "priceDown"
                      ? "block"
                      : "none",
                }}
                alt="Vector"
                src="Vector.svg"
              />
            </div>
          </div>
          <div style={{ flexBasis: "5%", flexGrow: 0 }}>
            <p className="is-size-6 has-text-weight-bold"></p>
          </div>
          <div style={{ flexBasis: "19.5%", flexGrow: 0 }}>
            <p className="is-size-6 has-text-weight-bold"></p>
          </div>
        </div>
        )}
        {pageIsLoaded ? "" : <LoadingPage />}
        {configuration.filteredResult.map((product, index) =>
          product.price ? (
            <LockSystemRow
              key={product.supllier + '-' + product.system1}
              product={product}
              index={index}
              expanded={expandedRows.includes(index)}
              onToggle={toggleRow}
              onSelect={handleOnSelectSystem}
              configuration={configuration}
              tableData={tableData}
              supplierIconMap={supplierIconMap}
            />
          ) : null
        )}
      </div>
      <div
        className="LockConfiguratorButons"
        style={{ width: "100%", marginTop: "3%", overflow: "hidden" }}
      >
        <Link to={"/1"}>
          <div className="LockConfiguratorButon">
            <div className="text-wrapper1">Zurück</div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default ChooseLockSystem;
